import * as React from 'react';
import * as palette from '@mlc/mlc-palette';

interface Props {
	parentRef: React.ReactInstance | null;
	position?: {
		left: number;
		right: number;
		width: number;
	};
	alignment?: 'left' | 'right';
	dataId: string;
	className?: string;
}

interface State {
	left: number;
	right: number;
	height: number;
	top: number;
	width: number;
	windowWidth: number;
}

export class ResponsiveLayout extends React.Component<Props, State> {
	_isMounted: boolean = true;

	state: State = {
		left: -1000,
		right: -1000,
		top: -1000,
		height: 0,
		width: 0,
		windowWidth: document.body.clientWidth,
	};

	componentDidMount() {
		const { parentRef } = this.props;
		this.updatePosition(parentRef);
		this._isMounted = true;
		window.addEventListener('resize', () => this.updatePosition(parentRef));
	}

	componentWillUnmount() {
		const { parentRef } = this.props;
		document.removeEventListener('resize', () =>
			this.updatePosition(parentRef)
		);
		this._isMounted = false;
	}

	updatePosition = (ref: React.ReactInstance | null) => {
		if (!ref || !(ref as any).getBoundingClientRect) {
			return;
		}
		const rectanglePosition = (ref as any).getBoundingClientRect();
		if (!this._isMounted) {
			return;
		}

		this.setState({
			left: rectanglePosition.left,
			right: rectanglePosition.right,
			top: rectanglePosition.top,
			height: rectanglePosition.height,
			width: rectanglePosition.width,
			windowWidth: document.body.clientWidth,
		});
	};

	render() {
		const {
			position = { left: 0, right: 0, width: 0 },
			alignment,
			className,
			dataId,
			children,
		} = this.props;
		const shouldAlignLeft =
			this.state.windowWidth > this.state.left + position.width;

		let positionStyle = {
			position: 'absolute' as 'absolute',
			zIndex: 1,
			//top: this.state.top + this.state.height,
			width: position.width,
			backgroundColor: palette.mlcWhite,
			justifyContent: 'flexStart',
		};

		if (shouldAlignLeft || alignment === 'left') {
			positionStyle = {
				...positionStyle,
			};
		}

		if (alignment === 'right' || !shouldAlignLeft) {
			positionStyle = {
				...positionStyle,
				// @ts-ignore
				left: this.state.width - position.width,
			};
		}

		if (!alignment) {
			positionStyle = {
				...positionStyle,
			};
		}

		return (
			<div
				style={positionStyle}
				data-id={dataId}
				className={className}
				data-alignment={alignment}
			>
				{children}
			</div>
		);
	}
}
export default ResponsiveLayout;
